export const GET_WMS_STOCK_REQUEST = "GET_WMS_STOCK_REQUEST";
export const GET_WMS_STOCK_SUCCESS = "GET_WMS_STOCK_SUCCESS";
export const GET_WMS_STOCK_FAILURE = "GET_WMS_STOCK_FAILURE";

export const DOWNLOAD_WMS_STOCK_REQUEST = "DOWNLOAD_WMS_STOCK_REQUEST";
export const DOWNLOAD_WMS_STOCK_SUCCESS = "DOWNLOAD_WMS_STOCK_SUCCESS";
export const DOWNLOAD_WMS_STOCK_FAILURE = "DOWNLOAD_WMS_STOCK_FAILURE";
